"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrigNode = void 0;
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'TRIGONOMETRY';
class TrigNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const inputNumber = params.inputNum !== null ? Number(params.inputNum) : NaN;
            if (isNaN(inputNumber)) {
                return { result: undefined };
            }
            const { functionType, unitType } = this.config;
            const multiplier = unitType === 'radians' ? 1 : 180 / Math.PI;
            const outputNum = this.getOutputNum(functionType, multiplier, inputNumber);
            const result = Number.isFinite(outputNum) ? outputNum : undefined;
            return { result };
        };
        this._interfaceDefinition = Schema;
    }
    arcFunctOrUndefined(functionType, multiplier, inputNum) {
        switch (functionType) {
            case 'Arcsin':
                if (inputNum >= -1 && inputNum <= 1) {
                    return Math.asin(inputNum) * multiplier;
                }
                break;
            case 'Arccos':
                if (inputNum >= -1 && inputNum <= 1) {
                    return Math.acos(inputNum) * multiplier;
                }
                break;
            case 'Arctan':
                return Math.atan(inputNum) * multiplier;
        }
        return undefined;
    }
    getOutputNum(functionType, multiplier, inputNum) {
        switch (functionType) {
            case undefined:
            case 'Sin':
                return Math.sin(inputNum / multiplier);
            case 'Cos':
                return Math.cos(inputNum / multiplier);
            case 'Tan':
                if ((multiplier === 1 && Math.abs(gen5_shared_utilities_1.mod(inputNum, Math.PI) - Math.PI / 2) > 1e-15) ||
                    (multiplier !== 1 && Math.abs(gen5_shared_utilities_1.mod(inputNum, 180)) !== 90)) {
                    return Math.tan(inputNum / multiplier);
                }
            default:
                break;
        }
        return this.arcFunctOrUndefined(functionType, multiplier, inputNum);
    }
}
exports.TrigNode = TrigNode;
TrigNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Trigonometry',
    isIdempotent: true,
    primaryCategory: 'Math',
};
//# sourceMappingURL=Trigonometry.js.map